<template class="out">
    <div class="app-footer">
        <div class="foot-1">
            <div class="h-30"></div>
            <div class="foot-1-content">
                <div class="tl pd5 row0">
                    <div class="defauleSel fl">
                        <span class="fs12">政府网站：</span>
                        <el-select v-model="value1" placeholder="请选择" :popper-append-to-body="false" @change="handleHref($event, selectOption1)">
                            <el-option
                                v-for="item in selectOption1"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                    <div class="defauleSel fl">
                        <span class="fs12">相关协会：</span>
                        <el-select v-model="value2" placeholder="请选择" :popper-append-to-body="false" @change="handleHref($event, selectOption2)">
                            <el-option
                                v-for="item in selectOption2"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                    <div class="defauleSel">
                        <span class="fs12">行业相关网站：</span>
                        <el-select v-model="value3" placeholder="请选择" :popper-append-to-body="false" @change="handleHref($event, selectOption3)">
                            <el-option
                                v-for="item in selectOption3"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id">
                            </el-option>
                        </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                    <div class="defauleSel">
                        <span class="fs12">国际相关组织：</span>
                        <el-select v-model="value4" placeholder="请选择" :popper-append-to-body="false" @change="handleHref($event, selectOption4)">
                            <el-option
                                v-for="item in selectOption4"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="tl pd20 row1">
                    <el-link class="mr-20 title" :underline="false" href="#" target="_blank" @click="handleJump('/')">首页</el-link>
                    <el-link class="mr-20 title" :underline="false" type="info" @click="handleJump('/AboutUs?tab=1')">协会简介</el-link>
                    <el-link class="mr-20 title" :underline="false" type="info" @click="handleJump('/AboutUs?tab=2')">协会章程</el-link>
                    <el-link class="mr-20 title" :underline="false" type="info" @click="handleJump('/AboutUs?tab=3')">会长理事名单</el-link>
                    <el-link class="mr-20 title" :underline="false" type="info" @click="handleJump('/AboutUs?tab=4')">组织机构</el-link>
                    <el-link type="info title" :underline="false" @click="handleJump('/AboutUs?tab=5')"> 联系我们</el-link>
                </div>
                <div class="tl pd10 row2">
                    <div class="fl">
                        <img class="h-20" src="../../assets/images/tel.png" />
                        <span class="tel">021-54663100</span> 
                        <p class="tel pl23">021-54663096</p>
                    </div>
                    <div class="pl23 pd50">
                        <p class="addr">Email：shxiehui@secta.sh.cn</p>
                        <p class="addr">传真：021-54663093</p>
                        <p class="addr">地址：上海市黄浦区六合路98号港陆黄浦中心15A</p>
                        <p class="addr">邮编：200001</p>
                    </div>
                    <div class="fr">
                        <img class="img-w" src="../../assets/images/logo.png" />
                        <img width="85px" src="../../assets/images/erweima.jpg" />
                    </div>
                </div>
            </div>
            <div class="h-30"></div>
        </div>
        <div class="foot-2">
            <div class="w-880">上海市工程咨询行业协会@2018 All Rights Reserved, 保留版权所有 沪ICP备15013469号</div>
        </div>
    </div>
</template>

<script>
import {
    getLinkExchangeApi,
} from "@/api"

export default {
  name: 'common-footer',
  data () {
    return {
        selectOption1: [],
        selectOption2: [],
        selectOption3: [],
        selectOption4:[],
        value1: '',
        value2: '',
        value3: '',
        value4: ''
    }
  },
  created(){
    this.init()
  },
  methods:{
    async init(){
        const {data} = await getLinkExchangeApi()
        if (data) {
            this.selectOption1 = data.governmentList
            this.selectOption2 = data.societyList
            this.selectOption3 = data.industryList
            this.selectOption4 = data.internationalList
        }
    },
    handleHref(val, list){
        const selectedItem = list.filter((item) => { // 这里的chargingWorkNameList就是上面遍历的数据源
            return item.id === val
            // 筛选出匹配数据，是对应数据的整个对象
        })
        if (selectedItem[0].url) {
            window.open(selectedItem[0].url, 'blank')
        }
    },
    handleHref3(val){
        let selectedItem = this.selectOption3.find((item) => { // 这里的chargingWorkNameList就是上面遍历的数据源
            return item.id === val
        })
        window.open(selectedItem[0].url, 'blank')
    },
    handleJump(path){
      this.$router.push({
          path: path
      }, () => {})
    },
  }
}
</script>

<style lang="scss" scoped>
@import './Footer.scss';
</style>
<style lang="scss">
    .defauleSel{
        margin-top: 15px;
        vertical-align: middle;
        .el-select-dropdown{
            border: #2C4563;
        }
        .el-input__inner{
            background: #2C4563;
            border: #2C4563;
            border-radius: 0;
            color: #fff;
            height: 32px;
        }
        .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
            background: #2C4563;
        }
        .el-select-dropdown__item, .el-select-dropdown__item{
            background: #2C4563;
            color: #fff;
        }
        .el-select-dropdown__list{
            background: #2C4563;
            border: #2C4563;
        }
        .el-select .el-input .el-select__caret.el-input__icon::before {
            content: "\e790";
            color: #90A2BE;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -60%);
        }

        .el-select .el-input .el-select__caret {
            transform: rotateZ(0deg);
        }
        .el-popper .popper__arrow{
            border-bottom-color: #2C4563;
        }
        .el-popper .popper__arrow::after {
            border-bottom-color: #2C4563;
        }
    }
</style>
